export default "__VITE_ASSET__CF2Cznku__"